package fr.frux.shared.data.entitlements

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.entitlements.EntitlementsRefresher
import fr.frux.core.common.logging.Logger
import fr.frux.shared.domain.repository.AuthRepository

/**
 * Fournit au socle publicitaire (#527) la relecture de `/auth/me` qu'il ne peut pas faire lui-même.
 * Passe par [AuthRepository.getCurrentUser], seul écrivain des droits : il gère déjà la génération
 * de session, l'ancrage sur l'heure du serveur et le compte anonyme (droits résolus à `NONE` sans
 * appel réseau).
 */
@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class AuthEntitlementsRefresher(
    private val authRepository: AuthRepository,
) : EntitlementsRefresher {
    override suspend fun refresh() {
        authRepository
            .getCurrentUser()
            .onFailure { error -> Logger.i(TAG, "Entitlements refresh failed: ${error::class.simpleName}") }
    }

    private companion object {
        const val TAG = "Entitlements"
    }
}
